import styled from 'styled-components';
import React, { useState, useRef } from 'react';

import { desktops } from 'styling/breakpoints';
import { DropDownArrowIcon } from 'components/Icons';
import { useClickOutside } from 'hooks/useClickOutside';

const MobileMenuWrapper = styled.div`
  ${({ theme }) => `
    display: block;
    position: fixed;
    width: 100%;
    top: ${theme.heights.header}px;
    z-index: ${theme.zIndexes.subnavs};
    background-color: white;

    @media (${desktops}) {
      display: none;
    }
  `}
`;

export const MobileMenuItemsWrapper = styled.ul`
  list-style-type: none;
  background-color: white;
  margin: 0;
  padding: 12px 0;

  a {
    color: ${({ theme }) => theme.colors.greyDarker};
  }
`;

export const MobileMenuItem = styled.li`
  padding: 16px 30px;
`;

const CurrentItem = styled.div`
  display: flex;
  cursor: pointer;
  font-weight: 700;
  padding: 27px 30px;
  flex-direction: row;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.colors.greyLight};
`;

const RotateableArrow = styled(DropDownArrowIcon)`
  ${({ expanded }) => `
    margin-left: auto;
    ${expanded ? '' : 'transform: rotate(90deg)'}
  `}
`;

export const MobileMenu = ({ renderMenu, currentItem }) => {
  const [expanded, setExpanded] = useState(false);
  const menuWrapperRef = useRef();
  const toggleExpanded = () => setExpanded(!expanded);
  useClickOutside(menuWrapperRef, () => setExpanded(false));

  return (
    <MobileMenuWrapper ref={menuWrapperRef}>
      <CurrentItem onClick={toggleExpanded}>
        {currentItem} <RotateableArrow expanded={expanded} />
      </CurrentItem>
      <div>{expanded ? renderMenu({ setExpanded }) : null}</div>
    </MobileMenuWrapper>
  );
};
